import React, { useEffect, useState } from 'react'
import { NewsletterSubscribersListPresenter } from './newsletter-subscribers-list-presenter'
import { GetNewsletterSubscribersSearchParams } from '../../lib/types'
import { newsletterServices } from '../../services/newsletter-service'

const DEFAULT_LIMIT = 10
const DEFAULT_SEARCH_PARAMS: GetNewsletterSubscribersSearchParams = {
  limit: DEFAULT_LIMIT.toString(),
  offset: '0',
  keyword: '',
  sortBy: 'NEWEST_TO_OLDEST',
}
const DEFAULT_PAGINATION = {
  total: 0,
  limit: DEFAULT_LIMIT,
  count: 0,
  offset: 0,
}

const NewsletterSubscribersListContainer = () => {
  const [subscribers, setSubscribers] = useState<any[]>([])
  const [searchParams, setSearchParams] =
    useState<GetNewsletterSubscribersSearchParams>(DEFAULT_SEARCH_PARAMS)
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION)
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchSubscribers = async () => {
      setIsLoading(true)
      const res = await newsletterServices.getSubscribers(searchParams)
      if (res?.data?.subscribers && res.data.subscribers.length > 0) {
        setSubscribers(res.data.subscribers)
        if (res.data.pagination) {
          setPagination(res.data.pagination)
        }
      } else {
        setSubscribers([])
        setPagination(DEFAULT_PAGINATION)
      }
      setIsLoading(false)
    }
    fetchSubscribers()
  }, [currentPage, searchParams])

  const handleSearchParams = ({ name, value }: { name: string; value: string }) => {
    const { limit } = DEFAULT_PAGINATION
    setSearchParams((prev) => ({
      ...prev,
      offset: '0',
      limit: limit.toString(),
      [name]: value,
    }))
    setCurrentPage(1)
    setPagination(DEFAULT_PAGINATION)
  }

  const resetSearchParams = () => {
    setSearchParams(DEFAULT_SEARCH_PARAMS)
    setCurrentPage(1)
    setPagination(DEFAULT_PAGINATION)
  }

  const handleCurrentPage = (currentPage: number) => {
    const { limit } = DEFAULT_PAGINATION
    setCurrentPage(currentPage)
    setSearchParams((prev) => ({
      ...prev,
      offset: `${(currentPage - 1) * limit}`,
    }))
    setPagination((prev) => ({ ...prev, offset: (currentPage - 1) * limit }))
  }

  return (
    <NewsletterSubscribersListPresenter
      subscribers={subscribers}
      isLoading={isLoading}
      pagination={pagination}
      currentPage={currentPage}
      searchParams={searchParams}
      handleCurrentPage={handleCurrentPage}
      handleSearchParams={handleSearchParams}
      resetSearchParams={resetSearchParams}
    />
  )
}

export { NewsletterSubscribersListContainer }
